<template>
	<div class="p-x-20 p-y-12 bg-white" v-if="statusTracker !== 2">
		<span class="spinner-border spinner-border-sm f-c-midgrey m-r-12"
		      role="status"
		      aria-hidden="true"
		></span>
		<span class="f-regular f-14 f-c-black">Sedang mengekspor </span>
		<span class="f-regular f-14 f-c-midgrey" v-if="exportData.processed + exportData.total === 0">
			(sedang mengambil data...)
		</span>
		<span class="f-regular f-14 f-c-midgrey" v-else>
			({{ formatRupiah(exportData.processed) }} dari {{ formatRupiah(exportData.total) }} data)
		</span>
	</div>
	<div class="d-flex-between-center p-x-20 p-y-12 bg-white" v-else>
		<div class="d-block">
			<div class="f-regular f-14 f-c-black">
				Proses ekspor gagal
			</div>
			<div class="f-regular f-12 f-c-midgrey">
				Terjadi kesalahan saat mengekspor data.
			</div>
		</div>
		<img src="../../../../src/assets/icons/closeblue.svg" alt="" @click="exportFailed">
	</div>
</template>

<script>
export default {
	name: "SOExportProgressMinimized",
	props: {
		processedData: Number,
		totalData: Number,

		context: String,
		trackerActions: String,
		deleteActions: String,
	},
	data() {
		return {
			looper: null,
			delay: 5000,
			statusTracker: 0,

			exportData: {
				processed: 0,
				total: 0,
				mulitpeExportData: [],
			},
		}
	},
	mounted() {
		this.exportData.processed = this.processedData
		this.exportData.total = this.totalData

		this.runTrackerV2()
	},
	methods: { // same as SOExportProgress
		runTracker() {
			this.looper = setInterval(async () => {
				await this.tracker()
			}, this.delay);
		},
		runTrackerV2() {
			this.looper = setInterval(async () => {
				await this.trackerV2()
			}, this.delay);
		},
		async tracker() {
			const res = await this.$store.dispatch(this.trackerActions)
			if (res.success) {
				this.exportData.processed = res.data.progress_looping
				this.exportData.total = res.data.length_data

				this.statusTracker = parseInt(res.data.status_progress)
				switch (res.data.status_progress.toString()) {
					case "0": // onprogress
						break;
					case "1": // berhasil
						clearInterval(this.looper)
						this.$toast.success("Data " + this.context + " sukses di ekspor")

						this.downloadFile(res.data)
						this.$emit("on-success", res.data)
						break;
					case "2": // error
						clearInterval(this.looper)
						this.$toast.error(res.data.msg_progress)
						break;
					case "3": // tidak ada progress
						clearInterval(this.looper)
						// this.$toast.error(res.data.msg_progress)

						this.$emit("on-success")
						break;
					default:
						clearInterval(this.looper)
						this.$toast.error(res.data.msg_progress)

						this.statusTracker = 2
						break;
				}
			} else {
				clearInterval(this.looper)
				this.$toast.error(res.err)

				this.statusTracker = 2
			}
		},
		async trackerV2() {
			const res = await this.$store.dispatch(this.trackerActions)
			if (res.success) {
				if (res.data === null) {
					clearInterval(this.looper)
					this.$toast.error(res.msg)
					this.statusTracker = 2
					return
				}

				this.exportData.total = res.data.length
				this.exportData.processed = res.data.progress
				this.exportData.mulitpeExportData = res.data.info_data_export

				this.statusTracker = res.data.status
				switch (res.data.status) {
					case 0: // onprogress
						break;
					case 1: // berhasil
						clearInterval(this.looper)
						this.$toast.success("Data " + this.context + " sukses di ekspor")

						this.$emit("on-success")
						break;
					case 2: // error
						clearInterval(this.looper)
						this.$toast.error(res.data.error_message)
						break;
					case 3: // tidak ada progress
						clearInterval(this.looper)
						// this.$toast.error(res.data.msg_progress)

						this.$emit("on-success")
						break;
					default:
						clearInterval(this.looper)
						this.$toast.error(res.data.msg_progress)
						this.statusTracker = 2
						break;
				}
			} else {
				clearInterval(this.looper)
				this.$toast.error(res.err)
				this.statusTracker = 2
			}
		},
		downloadFile(data) {
			window.open(data.link_url, '_blank');
			setTimeout(() => {
				this.deleteFileExport(data.filename)
			}, 5000)
		},
		async deleteFileExport(filename) {
			const res = await this.$store.dispatch(this.deleteActions, filename)
		},
		exportFailed() {
			this.$emit("on-error")
		}
	}
}
</script>